import { useQueryClient } from "@tanstack/react-query";
import { useSocketEvent } from "@/lib/socket";
export function useRealtimeAi(projectId: string) {
  const client = useQueryClient();
  const refresh = (queryKey: (string | undefined)[]) => {
    const pending = client.getQueryState(queryKey)?.fetchStatus === "fetching";
    // An event can arrive while the first request still contains the old snapshot.
    void client.invalidateQueries({ queryKey }).then(() => {
      if (pending) return client.refetchQueries({ queryKey, type: "active" });
    });
  };
  useSocketEvent('ai:assistant-changed',()=>{for(const key of ['assistant-settings','assistant-calendar','assistant-automations','assistant-budget','ai-history','ai-conversations'])refresh([key]);},[]);
  const refreshCalendar = () => refresh(["assistant-calendar"]);
  useSocketEvent("task:created", refreshCalendar, []);
  useSocketEvent("task:updated", refreshCalendar, []);
  useSocketEvent("task:deleted", refreshCalendar, []);
  useSocketEvent<{ projectId: string; conversationId: string }>(
    "ai:conversation-changed",
    (data) => {
      if (projectId ? data.projectId !== projectId : !!data.projectId) return;
      refresh(["ai-conversations", projectId]);
      refresh(["ai-chat", data.conversationId]);
      refresh(["ai-history"]);
      refresh(["assistant-calendar"]);
    },
    [projectId],
  );
  useSocketEvent<{ projectId?: string }>(
    "ai:models-changed",
    (data) => {
      if (projectId && data.projectId && data.projectId !== projectId) return;
      refresh(["ai-project-models", projectId]);
      refresh(["ai-providers"]);
    },
    [projectId],
  );
  useSocketEvent<{ projectId?: string }>(
    "view:updated",
    (data) => {
      if (projectId && data.projectId && data.projectId !== projectId) return;
      void client.invalidateQueries({ queryKey: ["ai-references", projectId] });
      void client.invalidateQueries({
        queryKey: ["ai-reference-search", projectId],
      });
    },
    [projectId],
  );
  useSocketEvent(
    "connect",
    () => {
      refresh(["ai-project-models", projectId]);
      refresh(["ai-conversations", projectId]);
    },
    [projectId],
  );
}
